import { render, staticRenderFns } from "./BaseGroupExpansionPanels.vue?vue&type=template&id=6e96b28d&scoped=true&"
import script from "./BaseGroupExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./BaseGroupExpansionPanels.vue?vue&type=script&lang=js&"
import style0 from "./BaseGroupExpansionPanels.vue?vue&type=style&index=0&id=6e96b28d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e96b28d",
  null
  
)

export default component.exports